"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var awesome_phonenumber_1 = __importDefault(require("awesome-phonenumber"));
function validatePhone(t, phone) {
    var pn = new awesome_phonenumber_1.default(phone !== null && phone !== void 0 ? phone : '');
    if (pn.isValid()) {
        return undefined;
    }
    return t('validation:wrongPhone');
}
exports.validatePhone = validatePhone;
function validateEmail(t, mail) {
    if (mail) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return undefined;
        }
    }
    return t('validation:wrongEmail');
}
exports.validateEmail = validateEmail;
function requiredItem(t, value, fieldName) {
    if (value && value !== -1) {
        return undefined;
    }
    return t('validation:isRequired', { fieldName: fieldName });
    // return `${fieldName} is required`;
}
exports.requiredItem = requiredItem;
function required(t, value, fieldName) {
    if (value) {
        return undefined;
    }
    return t('validation:isRequired', { fieldName: fieldName });
}
exports.required = required;
function combine(validations) {
    if (validations) {
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, validations_1 = validations; _i < validations_1.length; _i++) {
            var validation = validations_1[_i];
            var errorMessage = validation();
            if (errorMessage) {
                return errorMessage;
            }
        }
    }
    return undefined;
}
exports.combine = combine;
//# sourceMappingURL=Validation.js.map